/**
 * 供应商管理
 */
export default {
  supplierInfoAudit: "/supplierInfo/audit", //   审核通过/不通过
  supplierInfoEnable: "/supplierInfo/enable", //   停用/启用
  supplierInfoSupplierAuditPageList: "/supplierInfo/supplierAuditPageList", //   供应商列表
  supplierInfoSupplierDetail: "/supplierInfo/supplierDetail", //   供应商详情
  supplierInfoSupplierPageList: "/supplierInfo/supplierPageList", //   供应商列表
  supplierDistributeList:'/supplierInfo/supplierSettlementDistributeList'// 分账设置列表
}
